<template>
  <div class="sysSet">
    <div class="top" @click="getVersion" v-if="isApp">
      <span>当前版本：{{version}}</span>
      <span>
        检查更新
        <van-icon name="arrow" />
      </span>
    </div>
    <div class="top" @click="$router.push('/mine/sys/resetPassword')">
      <span>重置密码</span>
      <span>
        <van-icon name="arrow" />
      </span>
    </div>
    <div class="updata_btn"  @click="updataRole">清除缓存</div>
    <div class="btn" @click="logout_fun">退出登录</div>
  </div>
</template>

<script>
import { logout, sendCode, codeLogin } from "@/api/login";
import { setToken, removeToken } from "@/utils/auth";
import { getVersion } from "@/api/public";
import { isAndroid,isIOS } from "@/utils/validate"
import Cookies from "@/utils/Cookies";
import {getUserAuth} from "@/api/public"
export default {
  name: "sysSet",
  data() {
    return {
      version:'1.0.0',
      isApp:window.plus ? true : false
    };
  },
  created() {},
  mounted() {
    try {
      if(plus){
        this.version = plus.runtime.version
      }
    } catch (error) {
      
    }
    // alert(JSON.stringify(navigator.appVersion))
    // alert(isAndroid())
  },
  methods: {
    //
    updataRole(){
      getUserAuth().then(res=>{
        if(res.code==200){
           Cookies.set("rule", JSON.stringify(res.data));
           this.$toast.success("清除成功");
        }else{
          this.$toast.fail(res.message);
        }
      })
    },
    // 退出登录
    logout_fun() {
      this.$dialog
        .confirm({
          title: "即将退出登录",
          message: "退出登录后开单购物车里的内容将被清空！",
          confirmButtonText:'退出'
        })
        .then(() => {
          logout().then(res => {
            if (res.code == 200) {
              removeToken();
              Cookies.remove("order_data");
              Cookies.remove("order_total_num");
              Cookies.remove("order_active_index");
              Cookies.remove("rule");
              this.$router.push({
                path: "/"
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },


    // 获取本地应用资源版本号
    getVersion(){
      var _this = this
      getVersion({type:isAndroid()?1:2}).then(res=>{
        if(res.code == 200 ){
          if(res.data.version != this.version){
            plus.nativeUI.alert("应用有新版本，是否立即下载更新？", function(event) {
              if(event.index == 0) {
                plus.runtime.openURL( res.data.url);
              }
            },"版本更新","下载")
          }else{
            this.$toast("当前已是最新版本！")
          }
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.sysSet {
  .top {
    line-height: 0.88rem;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 0 0.3rem;
    font-size: 0.32rem;
    > span:last-child {
      color: #999999;
    }
  }
  .updata_btn{
     width: 6.9rem;
    line-height: 0.88rem;
    text-align: center;
    background-color: #FB8A8A;
    color: #fff;
    font-size: 0.36rem;
     margin: 6rem auto 0;
    border-radius: 0.1rem;
    font-weight: bold;
    letter-spacing: 0.07rem;
  }
  .btn {
    width: 6.9rem;
    line-height: 0.88rem;
    text-align: center;
    background-color: #31b158;
    color: #fff;
    font-size: 0.36rem;
    margin: 1rem auto 0;
    border-radius: 0.1rem;
    font-weight: bold;
    letter-spacing: 0.07rem;
  }
}
</style>